
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinhingoli() {



const cardData = {
  keyword: 'Cab Service in Hingoli MIDC',
  heading: 'eTravo: Cab Service in Hingoli MIDC',
  headingDescription: `eTravo is proud to provide reliable and professional cab services in Hingoli MIDC, offering tailored transportation solutions for industries, corporate offices, and visiting professionals. Our services are designed to simplify employee commutes, executive travel, and client transfers within this developing industrial region. eTravo’s fleet consists of modern, air-conditioned, and GPS-enabled vehicles driven by well-trained, courteous drivers who follow corporate travel standards. We offer flexible rental plans, timely pickups and drops, and 24/7 support to ensure seamless travel management for businesses operating in Hingoli MIDC. With eTravo, experience stress-free, punctual, and comfortable cab services that drive efficiency in your day-to-day operations.`,

  top: 'Top Places to visit in Hingoli with eTravo',
   "topPlaces": [
    {
      "title": "Hingoli MIDC Industrial Area",
      "description": "Located in Limbala, the Hingoli MIDC Industrial Area hosts a variety of industries, including agro-processing units, seed processing facilities, and manufacturing plants. eTravo offers tailored transportation solutions to ensure timely and efficient employee commutes, supporting shift operations and enhancing industrial productivity."
    },
    {
      "title": "Hingoli City Center",
      "description": "The commercial and administrative heart of Hingoli, featuring government offices, banks, and corporate establishments. eTravo's executive cab services facilitate seamless travel for business meetings and official engagements, ensuring punctuality and comfort."
    },
    {
      "title": "Hingoli Deccan Railway Station",
      "description": "A crucial railway hub connecting Hingoli with major cities across India. eTravo provides convenient pickup and drop services, bridging the gap between rail travel and workplace commutes for employees and business travelers."
    },
    {
      "title": "Kalamnuri Industrial Area",
      "description": "An emerging industrial zone focusing on agro-based industries such as soybean products, jaggery, and bio-coal briquettes. eTravo supports logistics personnel with scheduled and on-demand cab services, ensuring smooth operations and timely deliveries."
    },
    {
      "title": "Shivaji College, Hingoli",
      "description": "A premier educational institution attracting students and faculty from various regions. eTravo offers reliable transportation solutions for daily commutes, academic events, and inter-campus travel, promoting educational excellence."
    },
    {
      "title": "Government Polytechnic College, Hingoli",
      "description": "Located in the MIDC area, this institution is a hub for technical education. eTravo provides dependable cab services for students and faculty, ensuring timely arrivals and departures for academic activities."
    },
    {
      "title": "Lakshmi Lifecare Hospital, Hingoli",
      "description": "A key healthcare facility in the region. eTravo offers reliable cab services for healthcare professionals and patients, ensuring timely arrivals and departures from hospitals and clinics."
    },
    {
      "title": "District Civil Hospital, Hingoli",
      "description": "Serving as a major government healthcare center, the District Civil Hospital requires efficient transportation for staff and patients. eTravo's services are integral to the region's healthcare accessibility."
    },
    {
      "title": "Podar International School, Hingoli",
      "description": "An esteemed educational institution offering quality education. eTravo provides transportation solutions for students and faculty members, ensuring safe and timely commutes."
    },
    {
      "title": "Hingoli Retail and Shopping Centers",
      "description": "Facilitating transportation for employees and customers to and from major retail outlets and shopping centers in Hingoli. eTravo's services enhance the shopping experience by providing convenient and safe travel options."
    },
    {
      "title": "Hingoli Hospitality Sector",
      "description": "Providing transportation solutions for hotel staff and guests, ensuring seamless travel experiences within the hospitality industry. eTravo's services contribute to guest satisfaction and operational efficiency."
    }
  ],

services: [
  {
    name: 'Hingoli MIDC Corporate Cab Rentals',
    description: `Tailored corporate cab rental plans designed specifically for businesses operating in Hingoli MIDC. Our services include flexible long-term contracts and short-term rentals suitable for daily commutes, site visits, and event transport. We ensure seamless booking, a professional fleet maintained to high standards, and dedicated customer support for uninterrupted corporate mobility.`
  },
  {
    name: 'Employee Transport Cab Hingoli MIDC',
    description: `Comprehensive employee transport solutions aligned with factory and office shift timings in Hingoli MIDC. Our GPS-enabled vehicles and monitored routes guarantee timely pickups and drop-offs, ensuring employee safety, comfort, and punctuality. Dedicated support teams provide real-time assistance to handle any scheduling changes efficiently.`
  },
  {
    name: 'Business Cab Services Hingoli MIDC',
    description: `Reliable and flexible cab services catering to business owners, executives, and staff requiring transportation for meetings, client visits, and corporate errands. Experienced drivers familiar with local traffic patterns provide timely and comfortable travel, helping businesses stay productive and on schedule.`
  },
  {
    name: 'Corporate Staff Cabs Hingoli MIDC',
    description: `Group transportation solutions designed for corporate teams, featuring multi-route planning, GPS tracking, and coordinated batch pickups. This service enhances cost-efficiency, reduces traffic congestion, and improves employee satisfaction by ensuring a smooth and safe commuting experience.`
  },
  {
    name: 'Reliable Corporate Cab Service Hingoli MIDC',
    description: `Our commitment to excellence ensures a consistently reliable corporate cab service with well-maintained vehicles and courteous, professional drivers. We emphasize punctuality, proactive communication, and a client-focused approach to meet all corporate transportation needs effectively.`
  },
  {
    name: 'AC Corporate Cabs Hingoli MIDC',
    description: `Comfort-oriented air-conditioned cabs providing a refreshing and pleasant travel experience regardless of Hingoli’s weather. Perfect for daily commutes and executive transportation, our AC fleet guarantees a cool, relaxed journey during peak summer or humid conditions.`
  },
  {
    name: 'Staff Pickup and Drop Cab Hingoli MIDC',
    description: `Flexible and dependable staff pickup and drop services supporting multiple shifts, including night duties. Our 24/7 availability and experienced drivers ensure your workforce travels safely and punctually, with easy schedule adjustments to accommodate changing shift patterns.`
  },
  {
    name: 'Affordable Business Cab Rentals Hingoli MIDC',
    description: `Cost-effective cab rental solutions designed for small to large businesses, with transparent pricing and adaptable vehicle deployment. Our scalable packages help organizations optimize transport budgets without compromising on service quality or reliability.`
  },
  {
    name: 'Executive Cab Services Hingoli MIDC',
    description: `Premium executive cab services featuring luxury vehicles and professionally trained chauffeurs. Ideal for airport transfers, VIP meetings, and client hospitality, providing a comfortable and discreet travel experience for senior management and guests.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Hingoli MIDC',
    description: `Streamlined monthly rental plans with fixed routes that simplify transportation logistics and administration. These plans provide consistent, hassle-free service with easy billing and close coordination with HR and operations teams to adjust to evolving business needs.`
  },
  {
    name: 'Industrial Area Employee Transport Hingoli MIDC',
    description: `Optimized employee transportation solutions for factories and industrial units in Hingoli MIDC. Our routing ensures safe, punctual, and efficient commutes, with compliance to industrial safety standards and seamless coordination for multiple shifts.`
  },
  {
    name: 'Corporate Client Cabs Hingoli MIDC',
    description: `Professional client transportation services that ensure visiting business guests experience punctual, comfortable, and polished travel. From airport pickups to facility tours, we help create a positive impression with high standards of service and vehicle maintenance.`
  },
  {
    name: 'Business Meeting Cabs Hingoli MIDC',
    description: `Quick-response cab services designed for executives attending important meetings within Hingoli and surrounding areas. Our prompt booking system, experienced drivers, and efficient routing ensure you never miss a critical business engagement.`
  },
  {
    name: 'Hingoli Industrial Area Cab Hire',
    description: `Flexible and on-demand cab hire for travel across Hingoli’s industrial corridors. Ideal for site inspections, logistics support, and business errands, our drivers are knowledgeable about the industrial landscape and local traffic conditions, ensuring hassle-free journeys.`
  },
  {
    name: 'Corporate Shuttle Cabs Hingoli MIDC',
    description: `Bulk employee transport services using minibuses and large vans, suitable for shift changes, corporate events, and group outings. These shuttles help reduce operational costs, lower the environmental footprint, and improve workforce coordination and safety.`
  }
],

tableData: [
  ['Hingoli MIDC Corporate Cab Rentals', 'Employee Transport Cab Hingoli MIDC'],
  ['Business Cab Services Hingoli MIDC', 'Corporate Staff Cabs Hingoli MIDC'],
  ['Reliable Corporate Cab Service Hingoli MIDC', 'AC Corporate Cabs Hingoli MIDC'],
  ['Staff Pickup and Drop Cab Hingoli MIDC', 'Affordable Business Cab Rentals Hingoli MIDC'],
  ['Executive Cab Services Hingoli MIDC', 'Monthly Corporate Cab Rentals Hingoli MIDC'],
  ['Industrial Area Employee Transport Hingoli MIDC', 'Corporate Client Cabs Hingoli MIDC'],
  ['Business Meeting Cabs Hingoli MIDC', 'Hingoli Industrial Area Cab Hire'],
  ['Corporate Shuttle Cabs Hingoli MIDC', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Cab Services for Hingoli MIDC",
    "WhyChoosedescription": "eTravo provides customized cab services designed specifically for businesses in Hingoli MIDC. Our solutions focus on ensuring punctual employee transportation, reducing downtime, and improving operational productivity within this developing industrial area."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Corporate Needs",
    "WhyChoosedescription": "Our diverse fleet includes sedans, SUVs, and multi-utility vehicles, giving businesses the flexibility to choose the best option for executive travel, staff commutes, or client visits. All vehicles are well-maintained to ensure safety and comfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Knowledge",
    "WhyChoosedescription": "Our drivers are professionally trained and possess comprehensive knowledge of Hingoli MIDC’s roads and industrial layout, enabling efficient navigation, timely pickups, and a professional travel experience."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Match Shift Patterns",
    "WhyChoosedescription": "We offer flexible booking models including scheduled pickups, on-demand rides, and long-term contracts to accommodate the varied shift patterns commonly found in industrial sectors."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
    "WhyChoosedescription": "All our vehicles come equipped with GPS tracking, allowing corporate clients to monitor rides in real time. This enhances passenger safety, driver accountability, and provides full transparency."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "We provide clear and detailed billing statements that include trip summaries and fare breakdowns, simplifying financial management and expense tracking for businesses."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Standards",
    "WhyChoosedescription": "Our fleet is regularly sanitized and maintained, and our drivers follow strict hygiene protocols to ensure a safe and healthy travel environment."
  },
  {
    "WhyChooseheading": "Dedicated Account Management Support",
    "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager to assist with bookings, address queries promptly, and ensure a smooth and customized cab service experience in Hingoli MIDC."
  }
]




}

const faqData = [
  [
    {
      question: "Which areas do your Hingoli MIDC cab services cover?",
      answer: "Our services cover the entire Hingoli MIDC region and surrounding industrial sectors, offering reliable daily transportation for employees."
    },
    {
      question: "Can we book recurring rides for factory shifts?",
      answer: "Yes, we offer flexible scheduling options for recurring rides based on fixed or rotating shift requirements."
    },
    {
      question: "Is consolidated monthly billing available for our company?",
      answer: "Yes, we provide consolidated monthly invoices along with detailed trip reports to streamline corporate expense tracking."
    },
    {
      question: "Are your drivers trained for industrial and corporate transport?",
      answer: "Absolutely. All our drivers are professionally trained in corporate etiquette, route familiarity, and safety protocols."
    },
    {
      question: "What safety features are included in your cab service?",
      answer: "Our fleet includes GPS tracking, routine vehicle sanitization, trained drivers, and 24/7 support for emergencies."
    },
    {
      question: "Do you offer dedicated support for business clients?",
      answer: "Yes, we assign dedicated account managers to our corporate clients to ensure priority service and quick resolutions."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Vijay Rathod",
    designation: "Production Manager, Hingoli Engineering Works",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s dependable cab service has improved the punctuality and safety of our employee transport. Very satisfied with the service.”"
  },
  {
    name: "Ms. Neeta Salunkhe",
    designation: "HR Head, Hingoli Polymers Pvt. Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“Professional drivers, clean cabs, and responsive support—eTravo is the perfect transportation partner for our operations in Hingoli MIDC.”"
  }
];




































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Hingoli MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-hingoli-midc.jpg",
  "description": "Reliable corporate cab service in Hingoli MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-hingoli-midc"
  }
};






    return (
        <div>

<Helmet>
  <title>Cab Service in Hingoli MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Hingoli MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/84.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinhingoli;